import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { AddressChangeForm } from './AddressChangeForm'

/**
 * Address change is used when there is a need to manually update a person's whereabouts, since it will not be updated via the usual channels.
 *
 * Here it is also possible to enter more, alternative addresses for that person.
 *
 * @links
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api legalentity-shared/AddressChangeCommandData, Address change command@
 */
export function AddressChangeCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, legalEntityId } = useHook(
    'routing.general.useLegalEntityParams',
  )()
  const actions = useHook('mutators.crm.useChangeAddressActions')({
    tenantId,
    personId: legalEntityId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.AddressChangeCommandData"
      title={translate('action.changeAddress.button')}
      commandDataForm={AddressChangeForm}
      submit={submit}
      {...props}
    />
  )
}
